const deleteValue = ({ commit }, payload) => {
    commit('DELETE_VALUE', payload);
};

const updateContextValue = ({ commit }, payload) => {
    commit('UPDATE_CONTEXT_VALUE', payload);
};

const updateValue = ({ commit }, payload) => {
    commit('UPDATE_VALUE', payload);
};

const updateValues = ({ commit }, payload) => {
    commit('UPDATE_VALUES', payload);
};

const resetValues = ({ commit }) => {
    commit('RESET_VALUES');
};

export default {
    deleteValue,
    updateContextValue,
    updateValue,
    updateValues,
    resetValues,
};
